import { useEffect, useState } from "react";
import { useUserContext } from "../useUserContext";
import { subscribeToSupportTicketEvents } from "@/app/_firebase/support";
import { SupportTicketEvent } from "@/app/@types/support";

const useSupportTicketEvents = (ticketId: string | null) => {
  const user = useUserContext();
  const [events, setEvents] = useState<SupportTicketEvent[]>([]);
  const [isLoading, setIsLoading] = useState(!!ticketId);

  useEffect(() => {
    if (!ticketId) {
      setEvents([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const unsubscribe = subscribeToSupportTicketEvents(
      user.uid,
      ticketId,
      (data) => {
        setEvents(data);
        setIsLoading(false);
      },
      (error) => {
        console.error("Support ticket events subscription failed", error);
        setIsLoading(false);
      }
    );
    return () => unsubscribe();
  }, [user.uid, ticketId]);

  return { events, isLoading };
};

export default useSupportTicketEvents;
